"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConverterUtils_1 = require("../../../core/utils/ConverterUtils");

var NChangedProdThreshold_1 = require("../model/NChangedProdThreshold");

var NChangedProdThresholdConverter_1 = require("./NChangedProdThresholdConverter");
/**
 * @author Tomas Leity
 */


var NChangedProdThresholdConverterImpl =
/*#__PURE__*/
function (_NChangedProdThreshol) {
  _inherits(NChangedProdThresholdConverterImpl, _NChangedProdThreshol);

  function NChangedProdThresholdConverterImpl() {
    _classCallCheck(this, NChangedProdThresholdConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(NChangedProdThresholdConverterImpl).apply(this, arguments));
  }

  _createClass(NChangedProdThresholdConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new NChangedProdThreshold_1.NChangedProdThreshold(NChangedProdThreshold_1.NChangedProdThreshold.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), NChangedProdThreshold_1.NChangedProdThreshold.schema.productName.valueOf(source.productName), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoVolume.valueOf(conversions.toBigNumber(source.promoVolume)), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoVolumeOld.valueOf(ConverterUtils_1.ConverterUtils.toBigNumberOrNull(conversions, source.promoVolumeOld)), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoVolumeAbsTh.valueOf(source.promoVolumeAbsTh), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoVolumeRelTh.valueOf(source.promoVolumeRelTh), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoPrice.valueOf(conversions.toBigNumber(source.promoPrice)), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoPriceOld.valueOf(ConverterUtils_1.ConverterUtils.toBigNumberOrNull(conversions, source.promoPriceOld)), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoPriceAbsTh.valueOf(source.promoPriceAbsTh), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoPriceRelTh.valueOf(source.promoPriceRelTh), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoPurchasePrice.valueOf(ConverterUtils_1.ConverterUtils.toBigNumberOrNull(conversions, source.promoPurchasePrice)), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoPurchasePriceOld.valueOf(ConverterUtils_1.ConverterUtils.toBigNumberOrNull(conversions, source.promoPurchasePriceOld)), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoPurchasePriceAbsTh.valueOf(source.promoPurchasePriceAbsTh), NChangedProdThreshold_1.NChangedProdThreshold.schema.promoPurchasePriceRelTh.valueOf(source.promoPurchasePriceRelTh), NChangedProdThreshold_1.NChangedProdThreshold.schema.unitBackDiscount.valueOf(ConverterUtils_1.ConverterUtils.toBigNumberOrNull(conversions, source.unitBackDiscount)), NChangedProdThreshold_1.NChangedProdThreshold.schema.unitBackDiscountOld.valueOf(ConverterUtils_1.ConverterUtils.toBigNumberOrNull(conversions, source.unitBackDiscountOld)), NChangedProdThreshold_1.NChangedProdThreshold.schema.unitBackDiscountAbsTh.valueOf(source.unitBackDiscountAbsTh), NChangedProdThreshold_1.NChangedProdThreshold.schema.unitBackDiscountRelTh.valueOf(source.unitBackDiscountRelTh));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        productName: source.productName,
        promoVolume: conversions.fromBigNumber(source.promoVolume),
        promoVolumeOld: ConverterUtils_1.ConverterUtils.fromBigNumberOrNull(conversions, source.promoVolumeOld),
        promoVolumeAbsTh: source.promoVolumeAbsTh,
        promoVolumeRelTh: source.promoVolumeRelTh,
        promoPrice: conversions.fromBigNumber(source.promoPrice),
        promoPriceOld: ConverterUtils_1.ConverterUtils.fromBigNumberOrNull(conversions, source.promoPriceOld),
        promoPriceAbsTh: source.promoPriceAbsTh,
        promoPriceRelTh: source.promoPriceRelTh,
        promoPurchasePrice: ConverterUtils_1.ConverterUtils.fromBigNumberOrNull(conversions, source.promoPurchasePrice),
        promoPurchasePriceOld: ConverterUtils_1.ConverterUtils.fromBigNumberOrNull(conversions, source.promoPurchasePriceOld),
        promoPurchasePriceAbsTh: source.promoPurchasePriceAbsTh,
        promoPurchasePriceRelTh: source.promoPurchasePriceRelTh,
        unitBackDiscount: ConverterUtils_1.ConverterUtils.fromBigNumberOrNull(conversions, source.unitBackDiscount),
        unitBackDiscountOld: ConverterUtils_1.ConverterUtils.fromBigNumberOrNull(conversions, source.unitBackDiscountOld),
        unitBackDiscountAbsTh: source.unitBackDiscountAbsTh,
        unitBackDiscountRelTh: source.unitBackDiscountRelTh
      });
      return result;
    }
  }]);

  return NChangedProdThresholdConverterImpl;
}(NChangedProdThresholdConverter_1.NChangedProdThresholdConverter);

exports.NChangedProdThresholdConverterImpl = NChangedProdThresholdConverterImpl;
/**
 * IOC Container qualifier
 */

NChangedProdThresholdConverterImpl.QUALIFIER = {
  documentType: NChangedProdThreshold_1.NChangedProdThreshold.name
};